import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Screen\GetScreenDossierByLocationController::__invoke
* @see app/Http/Controllers/Screen/GetScreenDossierByLocationController.php
* @route '/api/screen/data/get-dossier-by-location'
*/
const GetScreenDossierByLocationController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetScreenDossierByLocationController.url(options),
    method: 'get',
})

GetScreenDossierByLocationController.definition = {
    methods: ["get","head"],
    url: '/api/screen/data/get-dossier-by-location',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Screen\GetScreenDossierByLocationController::__invoke
* @see app/Http/Controllers/Screen/GetScreenDossierByLocationController.php
* @route '/api/screen/data/get-dossier-by-location'
*/
GetScreenDossierByLocationController.url = (options?: RouteQueryOptions) => {
    return GetScreenDossierByLocationController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Screen\GetScreenDossierByLocationController::__invoke
* @see app/Http/Controllers/Screen/GetScreenDossierByLocationController.php
* @route '/api/screen/data/get-dossier-by-location'
*/
GetScreenDossierByLocationController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetScreenDossierByLocationController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Screen\GetScreenDossierByLocationController::__invoke
* @see app/Http/Controllers/Screen/GetScreenDossierByLocationController.php
* @route '/api/screen/data/get-dossier-by-location'
*/
GetScreenDossierByLocationController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetScreenDossierByLocationController.url(options),
    method: 'head',
})

export default GetScreenDossierByLocationController